import React, { useEffect, useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';
import { FontSizeMultiplier } from '../../cvp-webgames-core/Misc/interfaces';
import { CustomGameDataConfig, CustomGameDataManager, TextHtmlTagType, generalAudioCaching } from '../../misc/tools';

import "./text-size.css"


class TextSizeCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'text-size',
				src: process.env.PUBLIC_URL + '/assets/images/text-size.svg'
			}
		];
	}
}

export const textSizeCaching = new TextSizeCaching();

let addOnColorSchemeChangedHandler : any = null;

const TextSize = (props: TextSizeConfig) => {
	const [savedData, setSavedData] = useState(null as CustomGameDataConfig);

	
	const [forcedUpdate, setForcedUpdate] = useState(false);
	const [textSizeVal, setTextSizeVal] = useState(0);
	const [isDarkTheme, setIsDarkTheme] = useState(Tools.isUsingDarkMode());

	useEffect(() => {
		addOnColorSchemeChangedHandler = Tools.addOnColorSchemeChanged((isDarkMode: boolean) => {
			setIsDarkTheme(isDarkMode);
		});

		return () => {
			Tools.removeOnColorSchemeChanged(addOnColorSchemeChangedHandler)
		}
	}, [])

	if(!savedData) {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			setSavedData(savedData.data);
		});
		return null;
	}
	
	

	if(textSizeVal !== savedData.fontSizeMultiplier) {
		setTextSizeVal(savedData.fontSizeMultiplier);
	}
	
	const getIconTheme = () => {
		return {
			filter: isDarkTheme ? 'invert(1)' : 'unset'
		}
	}
	const updateSize = (val: FontSizeMultiplier) => {
		if(textSizeVal === val) {
			return;
		}
		setTextSizeVal(val)
		Tools.getSaveData().then((updatedSaveData: CustomGameDataManager) => {
			updatedSaveData.data.fontSizeMultiplier = val;
			Tools.saveGame(updatedSaveData);
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.digi_plink_01).src;
			Tools.playOneShotSound(url);
			const forceUpdateUI = (window as any)['ui-force-update'];

			const focusedEl: any = document.activeElement.id;
			if(forceUpdateUI) {
				forceUpdateUI();
			}

			Tools.updateTextSize();

			setTimeout(() => {
				setForcedUpdate(!forceUpdateUI);
				setTimeout(() => {
					document.getElementById(focusedEl).focus();
				}, 0);
			}, 0);
		});
	}

	const getSize = () => {
		switch(textSizeVal) {
			case FontSizeMultiplier.small:
				return 'Default'
			case FontSizeMultiplier.med:
				return "Med"
			case FontSizeMultiplier.big:
				return "Big"
		}
	}
	return (
		<div className="center-element-horizontal main-content-inner text-size-container">
			<div className='text-size-container-img'>
				<img style={getIconTheme()} alt='' src={textSizeCaching.getItemByKey('text-size').src}/>
			</div>
			<br />
			<p className='text-size-container-text-title black-text'>{'Text Size - ' + getSize()}</p>
			<br />
			<div className='text-size-container-text-desc'>
				<p className='black-text'>The size of this sentence will change as you adjust the slider. Changes made here are automatically saved</p>
			</div>

			<div className='center-element-horizontal' style={{
				width: '360px',
				position: 'relative',
				height: '100px'
			}}>
				<div className='center-element' style={{height: '53px'}}>
					<p className="black-text" style={{position: 'absolute', top: '0', left: '0'}}><span style={{fontSize: '20pt'}}>A</span><span style={{width: '290px', display: 'inline-block'}}></span><span style={{fontSize: '40pt'}}>A</span></p>
					<div style={{
						position: 'absolute',
						width: '69%',
						bottom: '10px',
						left: '172px',
					}} className='center-element-horizontal'>
						<div style={{backgroundColor: 'black', width: '100%', height: '2px'}}></div>
						<div style={{ position: 'absolute', backgroundColor: 'black', width: '2px', height: '20px', bottom: '-8px'}} className="center-element-horizontal"></div>
						<div style={{ 
							position: 'absolute', 
							backgroundColor: 'white', 
							width: '30px', 
							height: '30px',
							borderRadius: '50px',
							border: '2px solid black', 
							bottom: '-14px',
							left: (() => {
								switch(textSizeVal) {
									case FontSizeMultiplier.small:
										return '0';
									case FontSizeMultiplier.med:
										return '108px';
									case FontSizeMultiplier.big:
										return '219px'
								}
							})()}}></div>
						<div style={{position: 'absolute', left: '0', top: '-15px', width: '100%', height: '31px'}}>
							<div style={{position: 'absolute', left: '-10px', top: '-10px', width: '51px', height: '51px'}} data-testid="test-text-size-small" tabIndex={0} id='text-size-0' onKeyUp={Tools.mapDivEnterToClick} onMouseMove={(m: any) => {
								if(m.buttons === 1) {
									updateSize(FontSizeMultiplier.small)
								}
							}}
							onPointerDown={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.small)
									event.target.releasePointerCapture(event.pointerId);
								}
							}}
							onPointerUp={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.small)
								}
							}}
							onPointerEnter={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.small)
								}
							}}
							onPointerLeave={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.small)
								}
							}} onClick={() => updateSize(FontSizeMultiplier.small)} role="button" aria-label={'Set text size to small'}></div>

							<div style={{position: 'absolute', left: '98px', top: '-10px', width: '51px', height: '51px' }} data-testid="test-text-size-med" tabIndex={0} id='text-size-1' onKeyUp={Tools.mapDivEnterToClick} onMouseMove={(m: any) => {
								if(m.buttons === 1) {
									updateSize(FontSizeMultiplier.med)
								}
							}}
							onPointerDown={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.med)
									event.target.releasePointerCapture(event.pointerId);
								}
							}}
							onPointerUp={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.med)
								}
							}}
							onPointerEnter={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.med)
								}
							}}
							onPointerLeave={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.med)
								}
							}} onClick={() => updateSize(FontSizeMultiplier.med)} role="button" aria-label={'Set text size to medium'}></div>

							<div style={{position: 'absolute', left: '209px', top: '-10px', width: '51px', height: '51px'}} tabIndex={0} id='text-size-2' data-testid="test-text-size-big" onKeyUp={Tools.mapDivEnterToClick} onMouseMove={(m: any) => {
								if(m.buttons === 1) {
									updateSize(FontSizeMultiplier.big)
								}
							}} onPointerDown={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.big)
									event.target.releasePointerCapture(event.pointerId);
								}
							}}
							onPointerUp={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.big)
								}
							}}
							onPointerEnter={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.big)
								}
							}}
							onPointerLeave={(event: any) => {
								if(Tools.isios()) {
									updateSize(FontSizeMultiplier.big)
								}
							}} onClick={() => updateSize(FontSizeMultiplier.big)} role="button" aria-label={'Set text size to big'}></div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	);

};

export interface TextSizeConfig {
}

export default TextSize;